
class FlowSettingModel {
    id: number=0;
    title?: string;
    flowId?: number|null;
    formTypeId?: number;
    isActive?: boolean;
    formType?: string;
    flowTitle?: string;
    displayOrder?: number;
    radWorkTypeId?: number;

    constructor(
        id: number,
        title: string,
        flowId: number,
        formTypeId: number,
        isActive: boolean,
        formType: string,
        flowTitle: string,
        displayOrder: number,
        radWorkTypeId: number,
    ) {
        this.id = id;
        this.title = title;
        this.flowId = flowId;
        this.formTypeId = formTypeId;
        this.isActive = isActive;
        this.formType = formType;
        this.flowTitle = flowTitle;
        this.displayOrder = displayOrder;
        this.radWorkTypeId = radWorkTypeId;
    }

    public static fromJson(json: any): FlowSettingModel {
        return new FlowSettingModel(
            json["id"],
            json["title"],
            json["flowId"],
            json["formTypeId"],
            json["isActive"],
            json["formType"],
            json["flowTitle"],
            json["displayOrder"],
            json["radWorkTypeId"],
        );
    }
}

// export class AffiliationCollaboratingModel {
//     [key: string]: any;
//     constructor(
//       public id: number = 0,
//       public name: string = "",
//       public keyCode: string = "",
//       public count: number = 0,
//     ) { }
  
//     public static fromJson(json: any): AffiliationCollaboratingModel {
//       var model = new AffiliationCollaboratingModel(
//         json["id"] || (json["Id"] || 0),
//         json["name"] || (json["Name"] || ""),
//         json["keyCode"] || (json["KeyCode"] || ""),
//         json["Count"] || (json["Count"] || 0),
//       );
//       for (const key in json) {
//         if (!(key in model)) {
//           model[key] = json[key];
//         }
//       }
//       return model;
//     }
//   }





export interface FlowSettingGetPayloadFilterModel {
    id?: number;
    title?: string;
    flowId?: number;
    formTypeId?: number;
    isActive?: number;
    radWorkTypeId?: number,
}

export interface FlowSettingGetPayloadModel {
    pageSize?: number;
    pageNumber?: number;
    Filters?: FlowSettingGetPayloadFilterModel;
}


export class  FlowSettingPayloadModel {
    id: number;
    title: string;
    flowId: number|null;
    formTypeId: number;
    isActive: boolean;
    formType: string;
    flowTitle: string;
    displayOrder: number;
    radWorkTypeId: number;

    constructor(
        id: number,
        title: string,
        flowId: number|null,
        formTypeId: number,
        isActive: boolean,
        formType: string,
        flowTitle: string,
        displayOrder: number,
        radWorkTypeId: number,
    ) {
        this.id = id;
        this.title = title;
        this.flowId = flowId;
        this.formTypeId = formTypeId;
        this.isActive = isActive;
        this.formType = formType;
        this.flowTitle = flowTitle;
        this.displayOrder = displayOrder;
        this.radWorkTypeId = radWorkTypeId;
    }

}
export default FlowSettingModel;
